import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../../settings/const";

export default class GmailSettingsModule extends SettingsModule {

    public initLink: string = "https://gsuite.google.com/marketplace/app/goodday/588823826282"

    constructor() {
        super({
            name                     : "Gmail",
            description              : "Convert emails into tasks, track their status and reply with a few clicks right from your native Gmail interface!",
            svgIcon                  : "isvg-gmail-integration",
            settingsUrl              : "settings/integrations/gmail",
            settingsMenuTopCategory  : SettingsMenuTopCategory.INTEGRATIONS,
            typeLabel                : "Integrations"

        });

        this.parentSection          = SettingsParentSection.INTEGRATIONS
    }

}
